function initLiveTradingPrice(event) {

  const section = event?.target?.classList?.contains('live-trading-price')
    ? event.target
    : document.querySelector('.live-trading-price');

  if (!section) return;

  // Prevent multiple intervals in theme editor
  if (section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  const API_KEY = section.dataset.apiKey;
  if (!API_KEY) {
    console.warn('No API key found');
    return;
  }

  const currency = section.dataset.currency || 'GBP';
  const markup = Number.parseFloat(section.dataset.markup) || 0;
  const karatMarkup = Number.parseFloat(section.dataset.karatMarkup) || 0;
  const metalMarkup = Number.parseFloat(section.dataset.metalMarkup) || 0;

  const KARATS = {
    '24k': 1,
    '22k': 0.916,
    '18k': 0.75,
    '14k': 0.585,
    '9k': 0.375
  };

  const cacheKey = 'metalPrices_' + currency;
  const refreshMinutes = Number.parseInt(section.dataset.refreshInterval, 10) || 30;
  const cacheTime = refreshMinutes * 60 * 1000;

  function fetchPrice() {
    fetch(`https://metals-api.com/api/latest?access_key=${API_KEY}&base=${currency}&symbols=XAU`)
      .then(res => res.json())
      .then(data => {
        if (!data.success) return;

        localStorage.setItem(cacheKey, JSON.stringify({
          time: Date.now(),
          data: data
        }));

        render(data);
      })
      .catch(err => console.error('Metals API error:', err));
  }

  // ---- CACHE CHECK ----
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    const parsed = JSON.parse(cached);
    if (Date.now() - parsed.time < cacheTime) {
      render(parsed.data);
    } else {
      fetchPrice();
    }
  } else {
    fetchPrice();
  }

  setInterval(fetchPrice, cacheTime);

  function render(data) {
    const ounceToGram = 31.1035;
    const goldPerOunce = data.rates.XAU;
    const goldPerGram = goldPerOunce / ounceToGram;

    section.querySelectorAll('[data-karat]').forEach(el => {
      const k = el.dataset.karat;
      let value = goldPerGram * KARATS[k];
      value = applyMarkup(value, karatMarkup);
      el.querySelector('.price').textContent = format(value);
    });

    setPrice('sovereign', applyMarkup(goldPerGram * 7.32, metalMarkup));
    setPrice('britannia', applyMarkup(goldPerOunce, metalMarkup));
    setPrice('krugerrand', applyMarkup(goldPerOunce, metalMarkup));

    section.querySelector('.updated-at').textContent =
      'Updated: ' + new Date().toLocaleString();
  }

  function setPrice(type, value) {
    const el = section.querySelector(`[data-metal="${type}"] .price`);
    if (el) el.textContent = format(value);
  }

  function applyMarkup(value, typeMarkup = 0) {
    let v = markup ? value + (value * markup / 100) : value;
    return typeMarkup ? v - (v * typeMarkup / 100) : v;
  }

  function format(value) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency
    }).format(value);
  }
}

// Normal load
document.addEventListener('DOMContentLoaded', initLiveTradingPrice);

// Shopify editor reload
document.addEventListener('shopify:section:load', initLiveTradingPrice);